import { Component, OnInit, ViewChild, ViewContainerRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { RoleConfigService, RoleConfig } from '../../services/role-config.service';
import { COMPONENT_MAPPING } from '../../component-mapping';

@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './dynamic-loader.component.html',
  styleUrls: ['./dynamic-loader.component.css']
})
export class DynamicLoaderComponent implements OnInit, AfterViewInit {
  userRole: string = 'internal';
  userName: string = '';

  // Reference to the container for dynamic components
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: true })
  dynamicContainer!: ViewContainerRef;

  constructor(
    private authService: AuthService,
    private roleConfigService: RoleConfigService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    console.log('DynamicLoaderComponent constructor called');
  }

  ngOnInit(): void {
    console.log('DynamicLoaderComponent ngOnInit called');
    // Retrieve user information (name and role) from localStorage
    const storedUser = localStorage.getItem('googleUser');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      // Show full name if length < 16, otherwise show only first name
      if (user.name.length >= 20) {
        this.userName = user.name.split(' ')[0] || 'User';
      } else {
        this.userName = user.name || 'User';
      }
    }
    // Force the role to be 'internal' regardless of what's in localStorage
    this.userRole = 'internal';
  }

  ngAfterViewInit(): void {
    console.log('DynamicLoaderComponent ngAfterViewInit called');
    // Load components after view is initialized
    setTimeout(() => {
      this.loadDynamicComponents();
    }, 0);
  }

  loadDynamicComponents(): void {
    console.log('Starting to load dynamic components...');
    // Load the JSON configuration for roles
    this.roleConfigService.getRoleConfig().subscribe(
      (config: RoleConfig) => {
        console.log('Received role config:', config);
        let componentIds: string[] = [];

        // Select the correct array based on current user role
        console.log('Current user role:', this.userRole);
        if (this.userRole === 'internal') {
          componentIds = config.internal;
        } else if (this.userRole === 'pilot') {
          componentIds = config.pilot;
        } else {
          componentIds = config.general;
        }
        console.log('Selected component IDs:', componentIds);

        // Clear the dynamic container before loading
        if (this.dynamicContainer) {
          console.log('Dynamic container found, clearing it...');
          this.dynamicContainer.clear();
        } else {
          console.error('Dynamic container is not initialized');
          return; // Exit if container is not available
        }

        // Loop over each component ID, look up its component, and create it dynamically
        componentIds.forEach(id => {
          console.log(`Looking up component for ID: ${id}`);
          const componentClass = COMPONENT_MAPPING[id];
          if (componentClass) {
            console.log(`Creating component for ID: ${id}`);
            try {
              const componentRef = this.dynamicContainer.createComponent(componentClass);
              console.log(`Component created successfully for ID: ${id}`, componentRef);
              
              // Force change detection
              this.cdr.detectChanges();
            } catch (error) {
              console.error(`Error creating component for ID: ${id}:`, error);
            }
          } else {
            console.warn(`No component mapped for ID: ${id}`);
          }
        });
      },
      error => {
        console.error('Error loading role config:', error);
      }
    );
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/']);
  }
}
